/** Marks a recovered feed-page row whose full message payload failed validation. */
export const ECHO_INVALID_MESSAGE_FLAG = 'echo:invalid-message';
/** Matches the fixed `h-6` invalid-message row rendered by MessageFeed. */
export const ECHO_INVALID_MESSAGE_ROW_HEIGHT_PX = 24;

/** Returns true when a projected item should render the invalid-message fallback row. */
export function isInvalidEchoMessage(item: { readonly flags?: readonly string[] } | undefined): boolean {
  return item?.flags?.includes(ECHO_INVALID_MESSAGE_FLAG) ?? false;
}
